/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_History_EmptyInputs */

const en_settings_history_empty = /** @type {(inputs: Settings_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No subscriptions yet.`)
};

const id_settings_history_empty = /** @type {(inputs: Settings_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada langganan.`)
};

/**
* | output |
* | --- |
* | "No subscriptions yet." |
*
* @param {Settings_History_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_history_empty = /** @type {((inputs?: Settings_History_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_History_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_history_empty(inputs)
	return en_settings_history_empty(inputs)
});